
import React from "react";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Search, List, Grid } from "lucide-react";

interface BlogFiltersProps {
  searchTerm: string;
  viewMode: "list" | "grid";
  tabFilter: string;
  onSearchChange: (value: string) => void;
  onViewModeChange: (mode: "list" | "grid") => void;
  onTabFilterChange: (value: string) => void;
}

const BlogFilters: React.FC<BlogFiltersProps> = ({
  searchTerm,
  viewMode,
  tabFilter,
  onSearchChange,
  onViewModeChange,
  onTabFilterChange,
}) => {
  return (
    <div className="bg-white p-6 rounded-lg shadow mb-6">
      <div className="flex flex-col md:flex-row gap-4 justify-between">
        <div className="relative flex-1 max-w-md">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 h-4 w-4" />
          <Input 
            placeholder="Buscar posts por título ou tag..." 
            className="pl-10"
            value={searchTerm}
            onChange={(e) => onSearchChange(e.target.value)}
          />
        </div>
        
        <div className="flex items-center gap-2">
          <Button
            variant={viewMode === "list" ? "default" : "outline"}
            size="sm"
            onClick={() => onViewModeChange("list")}
            className={viewMode === "list" ? "bg-toctoc-blue" : ""}
          >
            <List className="w-4 h-4" />
          </Button>
          <Button
            variant={viewMode === "grid" ? "default" : "outline"}
            size="sm"
            onClick={() => onViewModeChange("grid")}
            className={viewMode === "grid" ? "bg-toctoc-blue" : ""}
          >
            <Grid className="w-4 h-4" />
          </Button>
        </div>
      </div>
      
      {/* Status tabs */}
      <div className="mt-4">
        <Tabs defaultValue={tabFilter} onValueChange={onTabFilterChange}>
          <TabsList>
            <TabsTrigger value="all">Todos</TabsTrigger>
            <TabsTrigger value="published">Publicados</TabsTrigger>
            <TabsTrigger value="drafts">Rascunhos</TabsTrigger>
          </TabsList>
        </Tabs>
      </div>
    </div>
  );
};

export default BlogFilters;
